import { bridge } from '../bridge';

/**
 * 베타(디버그) 빌드 여부. 모듈 로드(런타임 시작) 시 1회 계산되는 상수.
 * `bridge.packageName` 은 네이티브 동기 상수(앱 세션 내 불변)라 모듈 평가 시점에 결정된다.
 * - Android 베타: applicationId suffix `.beta` (예: com.banhala.android.beta)
 * - iOS 베타: bundleIdentifier suffix `.stag` (예: com.banhala.banhala.stag)
 * - 스토어(prod) 빌드 및 web 에서는 false
 */
const packageName = bridge.packageName;

export const isBeta: boolean =
  packageName.endsWith('.beta') || packageName.endsWith('.stag');
